<template>
  <section>
    <div id="#app">
      <iframe
        src="http://47.103.87.196:5088/"
        width="100%"
        height="800"
        frameborder="0"
        scrolling="auto"
        id="iframename"
        name="iframename"
      ></iframe>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return { src1: "#" };
  },
  mounted() {
   
  }
};
</script>